import { render, staticRenderFns } from "./ConnectServiceDetails.vue?vue&type=template&id=3bd112fd&scoped=true&"
import script from "./ConnectServiceDetails.vue?vue&type=script&lang=js&"
export * from "./ConnectServiceDetails.vue?vue&type=script&lang=js&"
import style0 from "./ConnectServiceDetails.vue?vue&type=style&index=0&id=3bd112fd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd112fd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3bd112fd')) {
      api.createRecord('3bd112fd', component.options)
    } else {
      api.reload('3bd112fd', component.options)
    }
    module.hot.accept("./ConnectServiceDetails.vue?vue&type=template&id=3bd112fd&scoped=true&", function () {
      api.rerender('3bd112fd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/service/ConnectServiceDetails.vue"
export default component.exports